module.exports = __webpack_public_path__ + "img/toolbox.f9b0c9ab.jpg";